import React, { FC, useMemo } from 'react';
import './styles.css'; 
import Ballot from '../Ballot/Ballot';
import JackpotInstruct from '../JackpotInstruct/JackpotIntruct';
import IndicationLines from "../../../assets/background/indication-lines.png"; 

interface ColorPickProps {
    colors: string[];
}

const PickCard: React.FC<{ title: string; picks: number[], width: number }> = ({ title, picks, width }) => {
    return (
        <div className="pick-card d-flex flex-column mb-3 mx-auto" style={{ width: `${width}%` }}>
            <div className="d-flex px-3 justify-content-start">
                <div className="my-auto">
                    <h5 className="my-auto fw-bold" style={{ color: '#FF51D9' }}>
                        {title}
                    </h5>
                </div>
                {picks.map((pick, index) => (
                    <div key={index} className="my-auto mx-auto">
                        <p className="pick-card-pick-num my-auto">
                            {pick} <span className="pick-card-pick-num-pays">Paga</span>
                        </p>
                        <p className="pick-card-pick-num my-auto">RD$1.00</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

const ColorPick: React.FC<ColorPickProps> = ({ colors }) => {
    return (
        <div className="d-flex flex-column">
            {Array.from({ length: 4 }).map((_, colorIndex) => (
                <div className="d-flex justify-content-around" key={colorIndex}>
                    {Array.from({ length: 5 }).map((_, boxIndex) => (
                        <div
                            key={boxIndex}
                            className="color-pick-cont mb-2"
                            style={{ backgroundColor: colors[colorIndex] }}
                        >
                            <div className="text-end">
                                <p
                                    style={{
                                        marginBottom: 0,
                                        color:
                                            colors[colorIndex] === '#ffe200' || colors[colorIndex] === '#29ff7b' ? 'black' : 'white',
                                    }}
                                >
                                    {boxIndex === 0 ? 0 : boxIndex}+
                                </p>
                            </div>
                            <div className="color-pick-cont-text-cont">
                                <p className='mb-0'>RD$1.00</p>
                            </div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

const HowToPlay: FC = () => {
    const colors = useMemo(() => ["#29ff7b", "#ffe200", "#006eff", "#eb4034"], []);

    const getColor = (index: number): string => {
        if (index <= 11) {
            return index % 2 === 0 ? colors[0] : colors[1];
        } else {
            return index % 2 === 0 ? colors[3] : colors[2];
        }
    };

    const colores = ['#29ff7b','#ffe200',"#006eff", '#F70D02',  ];

    return (
        <div className="row justify-content-center gx-5 position-relative">
            <div className="position-absolute indication-lines w-100 h-100">
                <img className="h-100 w-100" src={IndicationLines} alt="Indication Lines" />
            </div>
            <div className="col-12 col-lg-12">
                <div className="row justify-content-around instructions h-100">
                    <div className="col-12 col-lg-5">
                        <div className="row">
                            {Array.from({ length: 24 }, (_, index) => (
                                <div className="col-2 mb-4" key={index}>
                                    <Ballot
                                        style={{
                                            height: '4rem',
                                            minHeight: '4rem',
                                            width: '4rem',
                                            minWidth: '4rem',
                                        }}
                                        color={getColor(index)}
                                    >
                                        <h2 className="fw-bold">{index + 1}</h2>
                                    </Ballot>
                                </div>
                            ))}
                            <div className="col-12 text-white mb-3">
                                <h4 className="mt-auto text-uppercase">
                                    Ganas acertando el <span style={{ color: '#29ff7b' }} className="fw-bold">color</span> de la primera bola y el 
                                    <span style={{ color: '#29ff7b',  }} className="fw-bold">primer número.</span>
                                </h4>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="pick-card d-flex flex-column mb-3 mx-auto w-100">
                                    <div className="d-flex py-1 px-3 justify-content-start">
                                        <div className="my-auto me-auto">
                                            <Ballot
                                                color="#29ff7b"
                                                style={{
                                                    height: '3rem',
                                                    minHeight: '3rem',
                                                    width: '3rem',
                                                    minWidth: '3rem',
                                                }}
                                            >
                                                <h4 className="fw-bold">17</h4>
                                            </Ballot>
                                        </div>
                                        <div className="my-auto mx-auto">
                                            <h5 className="pick-card-pick-num my-auto">1er Bola</h5>
                                        </div>
                                        <div className="my-auto mx-auto hg-win">
                                            <h6 className="pick-card-pick-num my-auto">
                                                <span className="pick-card-pick-num-pays">Paga</span>
                                            </h6>
                                            <h6 className="pick-card-pick-num my-auto">RD$1.00</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="pick-card d-flex flex-column mb-3 mx-auto w-100">
                                    <div className="d-flex py-1 px-3 justify-content-start">
                                        <div className="my-auto me-auto">
                                            <Ballot
                                                color="#29ff7b"
                                                style={{
                                                    height: '3rem',
                                                    minHeight: '3rem',
                                                    width: '3rem',
                                                    minWidth: '3rem',
                                                }}
                                            >
                                                <h4 className="fw-bold"></h4>
                                            </Ballot>
                                        </div>
                                        <div className="my-auto mx-auto">
                                            <h5 className="pick-card-pick-num my-auto">1er Color</h5>
                                        </div>
                                        <div className="my-auto mx-auto hg-win">
                                            <h6 className="pick-card-pick-num my-auto">
                                                <span className="pick-card-pick-num-pays">Paga</span>
                                            </h6>
                                            <h6 className="pick-card-pick-num my-auto">RD$1.00</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 text-white">
                                <h4 className="mt-auto text-uppercase pb-3">GANA ACERTANDO SI EL TOTAL DEL SORTEO ES PAR <span style={{ color: "#0094FF" }} className="fw-bold">PAR</span> O <span style={{ color: "#0094FF" }} className="fw-bold">IMPAR</span></h4>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="pick-card d-flex flex-column mb-3 mx-auto w-100">
                                    <div className="d-flex py-1 px-3 justify-content-start">
                                        <div className="my-auto me-auto text-start">
                                            <h6 className="pick-card-pick-num my-auto">Total Sorteo</h6>
                                            <h4 className="fw-bolder" style={{ color: "#0094FF " }}>PAR</h4>
                                        </div>
                                        <div className="my-auto ms-auto hg-win">
                                            <h6 className="pick-card-pick-num my-auto">
                                                <span className="pick-card-pick-num-pays">Paga</span>
                                            </h6>
                                            <h6 className="pick-card-pick-num my-auto">RD$1.00</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6 mb-0">
                                <div className="pick-card d-flex flex-column mb-0 mx-auto w-100">
                                    <div className="d-flex py-1 px-3 justify-content-start">
                                        <div className="my-auto me-auto text-start">
                                            <h6 className="pick-card-pick-num my-auto">Total Sorteo</h6>
                                            <h4 className="fw-bolder" style={{ color: "#0094FF" }}>IMPAR</h4>
                                        </div>
                                        <div className="my-auto ms-auto hg-win">
                                            <h6 className="pick-card-pick-num my-auto">
                                                <span className="pick-card-pick-num-pays">Paga</span>
                                            </h6>
                                            <h6 className="pick-card-pick-num my-auto">RD$1.00</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 text-white mb-3">
                                <h4 className="mt-auto  text-uppercase">GANA ACERTANDO SI EL TOTAL DEL SORTEO ESTÁ 
                                    <div><span style={{ color: "#E15F00" }} className="fw-bold">ARRIBA DE 75.5</span> O <span style={{ color: "#E15F00" }} className="fw-bold">DEBAJO DE 75.5</span></div>
                                </h4>
                            </div>

                            <div className="col-12 col-lg-6">
                                <div className="pick-card d-flex flex-column mb-3 mx-auto w-100">
                                    <div className="d-flex py-1 px-3 justify-content-start">
                                        <div className="my-auto me-auto text-start">
                                            <h6 className="pick-card-pick-num my-auto">Total Sorteo</h6>
                                            <h4 className="fw-bolder" style={{ color: "#E15F00" }}>SOBRE 75.5</h4>
                                        </div>
                                        <div className="my-auto ms-auto">
                                            <h6 className="pick-card-pick-num my-auto">
                                                <span className="pick-card-pick-num-pays">Paga</span>
                                            </h6>
                                            <h6 className="pick-card-pick-num my-auto">RD$1.00</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="pick-card d-flex flex-column mb-3 mx-auto w-100">
                                    <div className="d-flex py-1 px-3 justify-content-start">
                                        <div className="my-auto me-auto text-start">
                                            <h6 className="pick-card-pick-num my-auto">Total Sorteo</h6>
                                            <h4 className="fw-bolder" style={{ color: "#E15F00" }}>BAJO 75.5</h4>
                                        </div>
                                        <div className="my-auto ms-auto hg-win">
                                            <h6 className="pick-card-pick-num my-auto">
                                                <span className="pick-card-pick-num-pays">Paga</span>
                                            </h6>
                                            <h6 className="pick-card-pick-num my-auto">RD$1.00</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-2 text-white fw-bolder fst-italic my-auto">
                        <h4 className="mt-auto text-uppercase">Elije entre 2 a 6 números entre el 1 y el 24, en cualquier<div>orden</div></h4>
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                    </div>
                    <div className="col-12 col-lg-5 pt-3">
                        <div className="row">
                            <div className="col-12">
                                <div className="d-flex flex-column justify-content-center">
                                    <div className="text-center mb-3">
                                        <JackpotInstruct style={{ height: 'auto', width: '12rem' }} />
                                    </div>
                                    <PickCard title="Pick 6" picks={[3, 4, 5, 6]} width={100} />
                                    <PickCard title="Pick 5" picks={[2, 3, 4, 5]} width={90}/>
                                    <PickCard title="Pick 4" picks={[2, 3, 4]} width={80}/>
                                    <PickCard title="Pick 3" picks={[2, 3, 4]} width={70} />
                                    <PickCard title="Pick 2" picks={[2, 3]} width={60}/>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 mb-3 text-white mb-5">
                                        <h4>
                                            APUESTA 2 O MÁS <span className="fw-bold" style={{ color: '#FF51D9' }}>
                                                COLORES
                                            </span>
                                        </h4>
                                        <h4>
                                            APUESTA COLOR QUE <span className="fw-bold" style={{ color: '#F70D02' }}>
                                                “NO”
                                            </span> SALDRÁ
                                        </h4>
                                    </div>
                                    <ColorPick colors={colores} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HowToPlay;
